import React, {ReactElement} from 'react';
import {TimeSheetGroupType} from './../../../../../features/schedule/types';
import {SelectProps, SelectRootSlotProps} from '@mui/base/Select';
import {SVGS} from './../../../../../assets/images';
import {Select as BaseSelect} from '@mui/base/Select/Select';
import Listbox, {Option} from './../../../../../components/shared/listbox';
import {useMediaQuery} from 'react-responsive';
import styles from './schedule-type-selector.module.scss';

const Popup = React.forwardRef(function Popup(
    props: React.HTMLAttributes<HTMLDivElement> & { ownerState?: unknown },
    ref: React.ForwardedRef<HTMLDivElement>,
) {
    const { className, ownerState, ...other } = props;
    void ownerState;
    return <div {...other} ref={ref} className={`${styles.popup} ${className ?? ''}`.trim()} />;
});

const CustomButton = React.forwardRef(function CustomButton<
    TValue extends NonNullable<unknown>,
    Multiple extends boolean,
>(
    props: SelectRootSlotProps<TValue, Multiple>,
    ref: React.ForwardedRef<HTMLButtonElement>,
) {
    const { ownerState, className, ...other } = props;
    const isIconOnlyView = useMediaQuery({ minWidth: 1001, maxWidth: 1250 });
    const selectedValue = ownerState?.value as TimeSheetGroupType | undefined;
    const selectedIcon = selectedValue === TimeSheetGroupType.PROJECTVIEW
        ? <SVGS.ProjectsIcon />
        : <SVGS.EmployeesIcon />;

    return (
        <button type="button" {...other} ref={ref} className={`${styles.button} ${className ?? ''}`.trim()}>
            {isIconOnlyView && <span className={styles.groupingIcon}>{selectedIcon}</span>}
            <span className={styles.label}>{other.children}</span>
            <SVGS.KeyboardArrowDownIcon />
        </button>
    );
});

const Select = React.forwardRef(function Select<
    TValue extends NonNullable<unknown>,
    Multiple extends boolean,
>(props: SelectProps<TValue, Multiple>, ref: React.ForwardedRef<HTMLButtonElement>) {
    const slots: SelectProps<TValue, Multiple>['slots'] = {
        root: CustomButton,
        listbox: Listbox,
        popup: Popup,
        ...props.slots,
    };

    return <BaseSelect {...props} ref={ref} slots={slots} />;
}) as <TValue extends NonNullable<unknown>, Multiple extends boolean>(
    props: SelectProps<TValue, Multiple> & React.RefAttributes<HTMLButtonElement>,
) => ReactElement;

interface Props {
    value: TimeSheetGroupType;
    onChange: (value: TimeSheetGroupType | null) => void;
    disabled?: boolean;
}

const ViewSelector: React.FC<Props> = (props) => {

    return(<Select defaultValue={TimeSheetGroupType.EMPLOYEEVIEW}
        value={props.value} multiple={false} 
        onChange={(event, value) => props.onChange(value)}
        disabled={props.disabled}>
        <Option value={TimeSheetGroupType.EMPLOYEEVIEW}>Employees</Option>
        <Option value={TimeSheetGroupType.PROJECTVIEW}>Projects and Absences</Option>
    </Select>)
}
export default ViewSelector;
